import { render } from "./ContentRecipeComposerNew.vue?vue&type=template&id=5736d864&scoped=true"
import script from "./ContentRecipeComposerNew.vue?vue&type=script&lang=js"
export * from "./ContentRecipeComposerNew.vue?vue&type=script&lang=js"

import "./ContentRecipeComposerNew.vue?vue&type=style&index=0&id=5736d864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5736d864"]])

export default __exports__